import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckUserRole } from '../hooks/useCheckUserRole';
import Select from 'react-select';
import ThemeToggleButton from '../../components/ThemeToggleButton';

function KapanisOran() {
    const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [filters, setFilters] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [savedFilters, setSavedFilters] = useState([]); // Kaydedilen filtreler
    const [error, setError] = useState(null);
    const [page, setPage] = useState(1);
    const [perPage] = useState(50);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [success, setSuccess] = useState(null);
    const [userRole, setUserRole] = useState(localStorage.getItem('userRole')); // Kullanıcının rolünü al

    const navigate = useNavigate();

    const [matchDates, setMatchDates] = useState([]);
    const [selectedDate, setSelectedDate] = useState('');
    const [matches, setMatches] = useState([]);
    const [selectedMatch, setSelectedMatch] = useState('');
    const [sysMatchId, setSysMatchId] = useState(null);  // Seçilen maçın sys_match_id'sini tutacak state
    const [isDropdownClicked, setIsDropdownClicked] = useState(false);
    const [populateError, setPopulateError] = useState(null);
    const [populateSuccess, setPopulateSuccess] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState(''); // Filtre dropdown'unun seçili değeri
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [hiddenHeaders, setHiddenHeaders] = useState([]);


    const toggleHeaderVisibility = (header) => {
        if (hiddenHeaders.includes(header)) {
            setHiddenHeaders(hiddenHeaders.filter(h => h !== header));
        } else {
            setHiddenHeaders([...hiddenHeaders, header]);
        }
    };


    const matchOptions = matches
        .filter(match => match.sys_match_id) // sys_match_id olmayanları filtrele
        .map(match => ({
            value: match.sys_match_id,
            label: `${match.competition_name} | ${match.match_date} | ${match.home_team} - ${match.away_team}`,
        }));

    // Kullanıcı rolünü kontrol edin
    useCheckUserRole(['admin', 'editor', 'user', 'wait']);

    const columns = [
        {
            header: 'Genel Bilgiler',
            subColumns: [
                { header: 'Tarih', key: 'match_date' },
                { header: 'Ülke', key: 'country_name' },
                { header: 'Lig', key: 'competition_name' },
                // { header: 'Yıl', key: 'season_slug' },
                // { header: 'Kod', key: 'code' },
            ]
        },
        {
            header: 'Maç Bilgileri',
            subColumns: [
                // { header: 'Maç', key: 'match_name' },
                { header: 'Ev Sahibi', key: 'home_team' },
                { header: 'Deplasman', key: 'away_team' },
                //  { header: 'Kazanan', key: 'winner' },
                { header: 'İlk Yarı Sonucu', key: 'ht_score' }, // Güncellenmiş sütun
                { header: 'Maç Sonucu', key: 'ft_score' },
                { header: 'Toplam Gol', key: 'total_goals' },
                { header: 'İlk Yarı / Ms Sonuç', key: 'ht_ft_result' },
            ]
        },
        {
            header: 'Maç Sonucu Oranlar',
            subColumns: [
                { header: 'Ev', key: 'ft_1_odd' },
                { header: 'X', key: 'ft_x_odd' },
                { header: 'Dep', key: 'ft_2_odd' },
                { header: 'Kod', key: 'ft_code' },
            ]
        },
        {
            header: 'Maç Sonucu Çifte Şans Oranları',
            subColumns: [
                { header: 'Ev veya X', key: 'ft_1x_odd' },
                { header: 'Ev veya Dep', key: 'ft_12_odd' },
                { header: 'X veya Dep', key: 'ft_x2_odd' },
                { header: 'Kod', key: 'ft_dc_code' },
            ]
        },
        {
            header: 'Maç Sonu Alt/Üst Oranlar',
            subColumns: [
                { header: '0.5 Alt', key: 'under_05_odd' },
                { header: '0.5 Üst', key: 'over_05_odd' },
                { header: 'Kod', key: 'uo_05_code' },
                { header: '1.5 Alt', key: 'under_15_odd' },
                { header: '1.5 Üst', key: 'over_15_odd' },
                { header: 'Kod', key: 'uo_15_code' },

                { header: '2.5 Alt', key: 'under_25_odd' },
                { header: '2.5 Üst', key: 'over_25_odd' },
                { header: 'Kod', key: 'uo_25_code' },

                { header: '3.5 Alt', key: 'under_35_odd' },
                { header: '3.5 Üst', key: 'over_35_odd' },
                { header: 'Kod', key: 'uo_35_code' },

                { header: '4.5 Alt', key: 'under_45_odd' },
                { header: '4.5 Üst', key: 'over_45_odd' },
                { header: 'Kod', key: 'uo_45_code' },
                { header: '5.5 Alt', key: 'under_55_odd' },
                { header: '5.5 Üst', key: 'over_55_odd' },
                { header: 'Kod', key: 'uo_55_code' },

            ]
        },
        {
            header: 'İlk Yarı Alt/Üst',
            subColumns: [
                { header: '0.5 Alt', key: 'ht_under_05_odd' },
                { header: '0.5 Üst', key: 'ht_over_05_odd' },
                { header: 'Kod', key: 'ht_uo_05_code' },
                { header: '1.5 Alt', key: 'ht_under_15_odd' },
                { header: '1.5 Üst', key: 'ht_over_15_odd' },
                { header: 'Kod', key: 'ht_uo_15_code' },
                { header: '2.5 Alt', key: 'ht_under_25_odd' },
                { header: '2.5 Üst', key: 'ht_over_25_odd' },
                { header: 'Kod', key: 'ht_uo_25_code' },
            ]
        },
        {
            header: 'İlk Yarı Çifte Şans',
            subColumns: [
                { header: 'Ev veya X', key: 'ht_1x_odd' },
                { header: 'Ev veya Dep', key: 'ht_12_odd' },
                { header: 'X veya Dep', key: 'ht_x2_odd' },
                { header: 'Kod', key: 'ht_dc_code' },
            ]
        },

        {
            header: 'İlk Yarı Sonucu',
            subColumns: [
                { header: 'Ev', key: 'ht_1_odd' },
                { header: 'X', key: 'ht_x_odd' },
                { header: 'Dep', key: 'ht_2_odd' },
                { header: 'Kod', key: 'ht_code' },
            ]
        },

        {
            header: 'İkinci Yarı Sonucu',
            subColumns: [
                { header: 'Ev', key: 'sh_1_odd' },
                { header: 'X', key: 'sh_x_odd' },
                { header: 'Dep', key: 'sh_2_odd' },
                { header: 'Kod', key: 'sh_code' },
            ]
        },

        {
            header: 'Tek/Çift Gol',
            subColumns: [
                { header: 'Tek', key: 'odd_odd' },
                { header: 'Çift', key: 'even_odd' },
                { header: 'Kod', key: 'oe_code' },
            ]
        },

        {
            header: 'Toplam Gol',
            subColumns: [
                { header: '0-1', key: 'tgr_01_odd' },
                { header: '2-3', key: 'tgr_23_odd' },
                { header: '4-5', key: 'tgr_45_odd' },
                { header: '6+', key: 'tgr_6_odd' },
                { header: 'Kod', key: 'tgr_code' },
            ]
        },
        {
            header: 'Karşılıklı Gol',
            subColumns: [
                { header: 'Yok', key: 'bts_no_odd' },
                { header: 'Var', key: 'bts_yes_odd' },
                { header: 'Kod', key: 'bts_code' },
            ]
        },
        {
            header: 'İlk Yarı Sonuç/ Maç Sonuç',
            subColumns: [
                { header: '1/1', key: 'htft_11_odd' },
                { header: 'X/1', key: 'htft_x1_odd' },
                { header: '2/1', key: 'htft_21_odd' },
                { header: '1/X', key: 'htft_1x_odd' },
                { header: 'X/X', key: 'htft_xx_odd' },
                { header: '2/X', key: 'htft_2x_odd' },
                { header: '1/2', key: 'htft_12_odd' },
                { header: 'X/2', key: 'htft_x2_odd' },
                { header: '2/2', key: 'htft_22_odd' },
                { header: 'Kod', key: 'htft_code' },
            ]
        },
        {
            header: 'İlk Gol',
            subColumns: [
                { header: 'Ev', key: 'fg_1_odd' },
                { header: 'Dep', key: 'fg_2_odd' },
                { header: 'Gol Olmaz', key: 'fg_no' },
                { header: 'Kod', key: 'fg_code' },
            ]
        },
        {
            header: 'Maç Sonu Skoru',
            subColumns: [
                { header: '0-0', key: 'cs_00_odd' },
                { header: '0-1', key: 'cs_01_odd' },
                { header: '0-2', key: 'cs_02_odd' },
                { header: '0-3', key: 'cs_03_odd' },
                { header: '0-4', key: 'cs_04_odd' },
                { header: '0-5', key: 'cs_05_odd' },
                { header: '1-0', key: 'cs_10_odd' },
                { header: '1-1', key: 'cs_11_odd' },
                { header: '1-2', key: 'cs_12_odd' },
                { header: '1-3', key: 'cs_13_odd' },
                { header: '1-4', key: 'cs_14_odd' },
                { header: '1-5', key: 'cs_15_odd' },
                { header: '2-0', key: 'cs_20_odd' },
                { header: '2-1', key: 'cs_21_odd' },
                { header: '2-2', key: 'cs_22_odd' },
                { header: '2-3', key: 'cs_23_odd' },
                { header: '2-4', key: 'cs_24_odd' },
                { header: '0-6', key: 'cs_06_odd' },
                { header: '3-0', key: 'item.cs_30_odd' },
                { header: '3-1', key: 'item.cs_31_odd' },
                { header: '3-2', key: 'item.cs_32_odd' },
                { header: '3-3', key: 'item.cs_33_odd' },
                { header: '4-0', key: 'cs_40_odd' },
                { header: '4-1', key: 'cs_41_odd' },
                { header: '4-2', key: 'cs_42_odd' },
                { header: '5-0', key: 'cs_50_odd' },
                { header: '5-1', key: 'cs_51_odd' },
                { header: '6-0', key: 'cs_60_odd' },
                { header: 'Diğer', key: 'cs_other_odd' },
                { header: 'Kod', key: 'cs_code' },
            ]
        },
        {
            header: 'Maç Sonucu 1.5 Alt/Üst',
            subColumns: [
                { header: 'Ev 1.5 Alt', key: 'ft_1_u_15_odd' },
                { header: 'X 1.5 Alt', key: 'ft_x_u_15_odd' },
                { header: 'Dep 1.5 Alt', key: 'ft_2_u_15_odd' },
                { header: 'Ev 1.5 Üst', key: 'ft_1_o_15_odd' },
                { header: 'X 1.5 Üst', key: 'ft_x_o_15_odd' },
                { header: 'Dep 1.5 Üst', key: 'ft_2_o_15_odd' },
                { header: 'Kod', key: 'ft_uo_15_code' },
            ]
        },
        {
            header: 'Maç Sonucu 2.5 Alt/Üst',
            subColumns: [
                { header: 'Ev 2.5 Alt', key: 'ft_1_u_25_odd' },
                { header: 'X 2.5 Alt', key: 'ft_x_u_25_odd' },
                { header: 'Dep 2.5 Alt', key: 'ft_2_u_25_odd' },
                { header: 'Ev 2.5 Üst', key: 'ft_1_o_25_odd' },
                { header: 'X 2.5 Üst', key: 'ft_x_o_25_odd' },
                { header: 'Dep 2.5 Üst', key: 'ft_2_o_25_odd' },
                { header: 'Kod', key: 'ft_uo_25_code' },
            ]
        },
        {
            header: 'Maç Sonucu 3.5 Alt/Üst',
            subColumns: [
                { header: 'Ev 3.5 Alt', key: 'ft_1_u_35_odd' },
                { header: 'X 3.5 Alt', key: 'ft_x_u_35_odd' },
                { header: 'Dep 3.5 Alt', key: 'ft_2_u_35_odd' },
                { header: 'Ev 3.5 Üst', key: 'ft_1_o_35_odd' },
                { header: 'X 3.5 Üst', key: 'ft_x_o_35_odd' },
                { header: 'Dep 3.5 Üst', key: 'ft_2_o_35_odd' },
                { header: 'Kod', key: 'ft_uo_35_code' },
            ]
        },
        {
            header: 'Maç Sonucu 4.5 Alt/Üst',
            subColumns: [
                { header: 'Ev 4.5 Alt', key: 'ft_1_u_45_odd' },
                { header: 'X 4.5 Alt', key: 'ft_x_u_45_odd' },
                { header: 'Dep 4.5 Alt', key: 'ft_2_u_45_odd' },
                { header: 'Ev 4.5 Üst', key: 'ft_1_o_45_odd' },
                { header: 'X 4.5 Üst', key: 'ft_x_o_45_odd' },
                { header: 'Dep 4.5 Üst', key: 'ft_2_o_45_odd' },
                { header: 'Kod', key: 'ft_uo_45_code' },
            ]
        },
        //  {
        //    header: 'Maç Sonucu Daha Çok Korner',
        //  subColumns: [
        //    { header: 'Ev Daha Çok Korner', key: 'ft_max_crn_1_odd' },
        //    { header: 'X Daha Çok Korner', key: 'ft_max_crn_x_odd' },
        //    { header: 'Dep Daha Çok Korner', key: 'ft_max_crn_2_odd' },
        //    { header: 'Kod', key: 'ft_max_crn_code' },
        //  ]
        //  },
        // {
        //   header: 'Anlamadığım Başlık',
        //  subColumns: [
        //     { header: '5', key: 'max_crn_1_odd' }, // sor
        //    { header: '6', key: 'max_crn_x_odd' },
        //   { header: '7', key: 'max_crn_2_odd' },
        //  { header: 'Kod', key: 'max_crn_code' },
        // ]
        // },
        // {
        //    header: 'İlk Korner ',
        //   subColumns: [
        //     { header: 'Ev Sahibi', key: 'frst_crn_1_odd' },
        //    { header: 'Deplasman', key: 'frst_crn_2_odd' },
        //    { header: 'Korner Olmaz', key: 'frst_crn_no_odd' },
        //    { header: 'Kod', key: 'frst_crn_code' },
        //  ]
        // },
        {
            header: 'İlk Yarı Karşılıklı Gol',
            subColumns: [
                { header: 'Kg Yok', key: 'ht_btts_no_odd' },
                { header: 'Kg Var', key: 'ht_btts_yes_odd' },
                { header: 'Kod', key: 'ht_btts_code' },
            ]
        },
        {
            header: 'İlk Yarı Ev/Dep 0.5 Alt/Üst',
            subColumns: [
                { header: 'Ev 0.5 Alt', key: 'ht_home_u_05_odd' },
                { header: 'Ev 0.5 Üst', key: 'ht_home_o_05_odd' },
                { header: 'Kod', key: 'ht_home_uo05_code' },
                { header: 'Dep 0.5 Alt', key: 'ht_away_u_05_odd' },
                { header: 'Dep 0.5 Üst', key: 'ht_away_o_05_odd' },
                { header: 'Kod', key: 'ht_away_uo05_code' },
            ]
        },
        {
            header: 'Maç Sonu Dep 0.5/2.5 Alt/Üst',
            subColumns: [
                { header: '0.5 Alt', key: 'ft_away_u_05_odd' },
                { header: '0.5 Üst', key: 'ft_away_o_05_odd' },
                { header: 'Kod', key: 'ft_away_uo05_code' },
                { header: '1.5 Alt', key: 'ft_away_u_15_odd' },
                { header: '1.5 Üst', key: 'ft_away_o_15_odd' },
                { header: 'Kod', key: 'ft_away_uo15_code' },
                { header: '2.5 Alt', key: 'ft_away_u_25_odd' },
                { header: '2.5 Üst', key: 'ft_away_o_25_odd' },
                { header: 'Kod', key: 'ft_away_uo25_code' },
            ]
        },
        {
            header: 'Maç Sonu Ev 0.5/2.5 Alt/Üst',
            subColumns: [
                { header: '0.5 Alt', key: 'ft_home_u_05_odd' },
                { header: '0.5 Üst', key: 'ft_home_o_05_odd' },
                { header: 'Kod', key: 'ft_home_uo05_code' },
                { header: '1.5 Alt', key: 'ft_home_u_15_odd' },
                { header: '1.5 Üst', key: 'ft_home_o_15_odd' },
                { header: 'Kod', key: 'ft_home_uo15_code' },
                { header: '2.5 Alt', key: 'ft_home_u_25_odd' },
                { header: '2.5 Üst', key: 'ft_home_o_25_odd' },
                { header: 'Kod', key: 'ft_home_uo25_code' },
            ]
        },
    ];

    // Kayıtlı filtreleri getirme
    useEffect(() => {
        const filterType = 2;  // Kapanisoran sayfası için filter_type 2

        fetch(`/api/get_filters?filter_type=${filterType}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
            }
        })
            .then(response => response.json())
            .then(data => setSavedFilters(data))
            .catch(error => console.error('Filtreleme Hatası:', error));
    }, []);


    useEffect(() => {
        const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
        setIsLoggedIn(storedIsLoggedIn);
        console.log("User logged in status:", storedIsLoggedIn);
        if (!storedIsLoggedIn) {
            navigate('/login');
        } else {
            fetchData();
        }
    }, [filters, page]);




    const fetchData = () => {
        console.log("Fetching data with filters:", filters, "on page:", page);
        if (userRole === 'wait') {
            console.log("User has 'wait' role; skipping data fetch.");
            return; // 'wait' rolündeki kullanıcılar veri çekemez
        }
        setLoading(true);  // Veriyi çekerken loading true yapılır

        const { ft_score, ht_score, ...serverFilters } = filters || {};
        const queryString = new URLSearchParams({
          page,
          per_page: perPage,
          ...serverFilters
        }).toString();
        

        fetch(`/api/odd-list-full-view?${queryString}`)
            .then(response => response.json())
            .then(newData => {
                const processedData = newData.items.map(item => {
                    const homeHT = item.home_ht_score;
                    const awayHT = item.away_ht_score;
                    const homeFT = item.home_ft_score;
                    const awayFT = item.away_ft_score;
                
                    const totalGoals = (homeFT !== null && awayFT !== null)
                        ? parseInt(homeFT) + parseInt(awayFT)
                        : null;
                
                    const getResult = (home, away) => {
                        if (home === null || away === null) return null;
                        if (home > away) return '1';
                        if (home < away) return '2';
                        return 'X';
                    };
                
                    const htResult = getResult(homeHT, awayHT);
                    const ftResult = getResult(homeFT, awayFT);
                    const htFtResult = (htResult && ftResult) ? `${htResult}/${ftResult}` : null;
                
                    return {
                        ...item,
                        ht_score: (homeHT === null || awayHT === null) ? null : `${homeHT}-${awayHT}`,
                        ft_score: (homeFT === null || awayFT === null) ? null : `${homeFT}-${awayFT}`,
                        total_goals: totalGoals,
                        ht_ft_result: htFtResult,
                    };
                });                
                

                if (page === 1) {
                    setData(processedData);
                    setFilteredData(processedData);
                } else {
                    setData(prevData => [...prevData, ...processedData]);
                    setFilteredData(prevData => [...prevData, ...processedData]);
                }

                // Veri sayısını kontrol ediyoruz
                console.log("Number of items received:", newData.items.length);
                console.log("Items per page:", perPage);

                // Has more kontrolü
                setHasMore(newData.items.length === perPage);
                setLoading(false);
            })
            .catch(error => {
                setError(error);
                setLoading(false);
                console.error('Data fetch error:', error);
            });

    };

    const deleteFilter = (filterId) => {
        if (!window.confirm(`Bu filtreyi silmek istediğinize emin misiniz?`)) {
            return;
        }
    
        fetch('/api/delete-filter', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ id: filterId })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.error || 'Filtre silme başarısız');
                    });
                }
                return response.json();
            })
            .then(data => {
                console.log(data.message);
                setSavedFilters(prevFilters => prevFilters.filter(filter => filter.id !== filterId));
            })
            .catch(error => {
                console.error('Filtre Silinemedi:', error);
                setError('Filtre silme başarısız');
            });
    };
    


    const handleScroll = (e) => {
        console.log("Scrolling...");
        if (window.innerHeight + e.target.documentElement.scrollTop + 1 >= e.target.documentElement.scrollHeight) {
            console.log("Reached bottom of the page.");

            // `hasMore` ve `loading`'in durumunu kontrol ediyoruz
            console.log("Has more data?", hasMore);
            console.log("Loading data?", loading);

            if (hasMore && !loading) {
                console.log("Fetching next page...");
                setPage(prevPage => prevPage + 1);
            } else {
                console.log("No more data to fetch or currently loading.");
            }
        }
    };


    useEffect(() => {
        if (Object.keys(filters).length === 0) {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item =>
                Object.keys(filters).every(key => {
                    const filterValue = filters[key]?.toLowerCase() || '';  // filterValue null veya undefined ise boş string yap

                    // Eğer ht_score veya ft_score ise iki alanı da kontrol edelim
                    if (key === 'ht_score') {
                        const homeHtScore = item.home_ht_score !== null ? item.home_ht_score : '';  // Null kontrolü
                        const awayHtScore = item.away_ht_score !== null ? item.away_ht_score : '';  // Null kontrolü
                        const combinedHtScore = `${homeHtScore}-${awayHtScore}`.toLowerCase();
                        return combinedHtScore.includes(filterValue);
                    }

                    if (key === 'ft_score') {
                        const homeFtScore = item.home_ft_score !== null ? item.home_ft_score : '';  // Null kontrolü
                        const awayFtScore = item.away_ft_score !== null ? item.away_ft_score : '';  // Null kontrolü
                        const combinedFtScore = `${homeFtScore}-${awayFtScore}`.toLowerCase();
                        return combinedFtScore.includes(filterValue);
                    }

                    // Diğer alanlar için standart filtreleme, null kontrolü ekleyelim
                    return item[key]?.toString().toLowerCase().includes(filterValue);
                })
            );
            setFilteredData(filtered);
        }
    }, [filters, data]);



    useEffect(() => {
        console.log('Adding scroll event listener...');

        window.addEventListener('scroll', handleScroll);
        return () => {
            console.log('Removing scroll event listener...');
            window.removeEventListener('scroll', handleScroll);
        };
    }, [hasMore, loading]);

    const parseScore = (s) => {
        const m = (s || '').match(/^\s*(\d+)\s*-\s*(\d+)\s*$/);
        return m ? { home: m[1], away: m[2] } : null;
      };
      
      const handleFilterChange = (key, value) => {
        setInputValues(prev => ({ ...prev, [key]: value }));
      
        if (value === '') {
          setFilters(prev => {
            const nf = { ...prev };
            if (key === 'ft_score') {
              delete nf.home_ft_score;
              delete nf.away_ft_score;
            } else if (key === 'ht_score') {
              delete nf.home_ht_score;
              delete nf.away_ht_score;
            } else {
              delete nf[key];
            }
            return nf;
          });
          setPage(1);
          return;
        }
      
        if (debounceTimeout) clearTimeout(debounceTimeout);
      
        const newTimeout = setTimeout(() => {
          if (key === 'ft_score') {
            const p = parseScore(value);
            if (!p) return;
            setFilters(prev => ({
              ...prev,
              home_ft_score: p.home,
              away_ft_score: p.away
            }));
          } else if (key === 'ht_score') {
            const p = parseScore(value);
            if (!p) return;
            setFilters(prev => ({
              ...prev,
              home_ht_score: p.home,
              away_ht_score: p.away
            }));
          } else {
            if (value.length < 2) return;
            setFilters(prev => ({ ...prev, [key]: value }));
          }
          setPage(1);
        }, 1000);
      
        setDebounceTimeout(newTimeout);
      };
      

    const clearFilters = () => {
        setFilters({});
        setInputValues({});
        setPage(1);
        setSelectedDate(''); // Tarih dropdown'unu temizle
        setSelectedMatch(''); // Maç dropdown'unu temizle
        setSelectedFilter(''); // Filtre dropdown'unu temizle
    };

    // Filtreyi kaydetme işlevi
    const saveFilter = () => {
        const filterName = prompt("Filtre İçin Ad Girin:");
        if (!filterName) return;

        const filterData = filters;  // Current filters
        const filterType = 2;  // Kapanisoran sayfası için filter_type 2

        fetch('/api/save-filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({ filter_name: filterName, filter_data: filterData, filter_type: filterType })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.error || 'Filtre kaydetme başarısız');
                    });
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    console.error('Filtre kaydetme başarısız:', data.error);
                    setError(data.error);
                } else {
                    console.log(data.message);
                    setSuccess(data.message);
                }
            })
            .catch(error => {
                console.error('Network hatası:', error);
                setError('Network hatası');
            });
    };


    // Kaydedilmiş filtreyi uygula ve populate et
    const applyFilter = (filterData) => {
        console.log("Applying filter:", filterData);
        setFilters(filterData);
        setInputValues(filterData);  // Inputları da güncelle
        setPage(1);  // İlk sayfaya dön
    };

    // Populate Filter Fonksiyonu
    const populateFilter = async (filterName) => {
        if (!selectedMatch) {
            if (selectedDate) { // Tarih seçilmişse maç seçilmeli
                setPopulateError('Lütfen önce bir maç seçin.');
                return;
            }
            return; // Maç seçilmediği durumda hata vermesin
        }
        console.log("Populating filter:", filterName);
        try {
            const response = await fetch('/api/kapanis-populate-filter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    match_id: selectedMatch,
                    filter_name: filterName
                })
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'Filtre doldurulurken bir hata oluştu.');
            }

            console.log("Populated filter data:", result.populated_filter);
            // Doldurulmuş filtre verilerini uygulayın
            setFilters(result.populated_filter);
            setInputValues(result.populated_filter);
            setPage(1);
            setPopulateError(null);
        } catch (error) {
            console.error('Populate Filter Hatası:', error);
            setPopulateError(error.message);
        }
    };


    useEffect(() => {
        if (selectedMatch) {
            fetch(`/api/kapanis-get-match-id?match_id=${selectedMatch}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.sys_match_id) {
                        setSysMatchId(data.sys_match_id);
                        console.log('Alınan sys_match_id:', data.sys_match_id);
                    } else {
                        console.error('Maç sys_match_id alınamadı:', data.error);
                    }
                })
                .catch(error => console.error('sys_match_id alma hatası:', error));
        }
    }, [selectedMatch]);


    // İlk Dropdown için: Bugün ve yarın tarihlerini almak
    const handleDropdownClick = () => {
        if (!isDropdownClicked) {
            fetch('/api/match-dates', {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(dates => {
                    // Gelen tarihleri "Bugün", "Yarın", "Ertesi Gün" olarak eşleştir
                    const labels = ["Bugün", "Yarın", "Ertesi Gün"];
                    const formattedDates = dates.map((date, index) => ({
                        value: date,
                        label: labels[index] || date, // Eğer fazla tarih gelirse fallback olarak tarihi göster
                    }));

                    setMatchDates(formattedDates);
                    setIsDropdownClicked(true); // Sadece bir kez çağrı yap
                })
                .catch(error => console.error('Tarih alımında hata:', error));
        }
    };

    // İkinci Dropdown: Seçilen tarihe göre maçları almak
    useEffect(() => {
        if (selectedDate) {
            fetch(`/api/kapanis-matches-by-date?date=${selectedDate}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`,
                },
            })
                .then(response => response.json())
                .then(matches => setMatches(matches))
                .catch(error => console.error('Maç alımında hata:', error));
        }
    }, [selectedDate]);

    useEffect(() => {
        if (selectedMatch && selectedFilter) {
            // Mevcut filtreyi yeniden uygula
            const selectedFilterData = savedFilters.find(filter => filter.filter_name === selectedFilter)?.filter_data;
            if (selectedFilterData) {
                applyFilter(selectedFilterData);
                populateFilter(selectedFilter);
            }
        }
    }, [selectedMatch]);

    return (

        <>
            {loading && <div className="loader">
                <div className="loader-inner">
                    <div className="circle"></div>
                </div>
            </div>}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="full-width">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p>Kapanış Oranlar</p>
                                <h1>Tablosu</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {userRole === 'wait' ? (
                // Eğer kullanıcı 'wait' rolünde ise satın alma mesajı göster
                <div className="text-center">
                    <h2>Bu içeriği görüntüleyebilmek için üyelik satın almanız gerekmektedir.</h2>
                    <button className="btn btn-primary" onClick={() => navigate('/satinal')}>
                        Üyelik Satın Al
                    </button>
                </div>
            ) : (
                <div className="full-width filter">
                    <ThemeToggleButton />
                    <div className="row">
                        {/* Sol tarafta Kayıtlı Filtreler */}
                        <div className="col-lg-6">
                            <h3>Kayıtlı Filtreler</h3>

                            <div className="filter-container">
                                {/* İlk Dropdown: Tarih Seçimi */}
                                <select
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    onClick={handleDropdownClick}
                                    className="form-control filter-dropdown"
                                >
                                    <option value="">Tarih Seçin</option>
                                    {matchDates.map((item, index) => (
                                        <option key={index} value={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>

                                {/* İkinci Dropdown */}
                                {selectedDate && (
                                    <Select
                                        value={matchOptions.find(option => option.value === selectedMatch)}
                                        onChange={(selectedOption) => setSelectedMatch(selectedOption ? selectedOption.value : null)}
                                        options={matchOptions}
                                        placeholder="Maç Seçin"
                                        isSearchable
                                        classNamePrefix="filter-dropdown"
                                    />


                                )}

                                {/* Kaydedilmiş Filtreler */}
                                {!selectedDate && savedFilters.length > 0 && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <select
                                            className="form-control filter-dropdown"
                                            id="savedFilterDropdown"
                                            value={selectedFilter}
                                            onChange={(e) => {
                                                const selectedFilterName = e.target.value;
                                                setSelectedFilter(selectedFilterName); // Seçilen filtreyi state'e kaydedin
                                                if (selectedFilterName) {
                                                    const selectedFilter = savedFilters.find(filter => filter.filter_name === selectedFilterName);
                                                    if (selectedFilter) {
                                                        applyFilter(selectedFilter.filter_data);
                                                        populateFilter(selectedFilterName);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">Filtre Seçin</option>
                                            {savedFilters.map((filter, index) => (
                                                <option key={index} value={filter.filter_name}>
                                                    {filter.filter_name}
                                                </option>
                                            ))}
                                        </select>

                                        <button
    onClick={() => {
        const selectedFilterName = document.getElementById('savedFilterDropdown').value;
        const selectedFilter = savedFilters.find(f => f.filter_name === selectedFilterName);
        if (selectedFilter) {
            deleteFilter(selectedFilter.id);
        }
    }}
    className="btn btn-link delete-button"
>
    &times;
</button>

                                    </div>
                                )}

                                {/* Eğer tarih seçilmiş ama maç seçilmemişse, "Filtre"yi gizleyelim */}
                                {selectedDate && selectedMatch && savedFilters.length > 0 ? (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <select
                                            className="form-control filter-dropdown"
                                            id="savedFilterDropdown"
                                            value={selectedFilter}
                                            onChange={(e) => {
                                                const selectedFilterName = e.target.value;
                                                setSelectedFilter(selectedFilterName); // Seçilen filtreyi state'e kaydedin
                                                if (selectedFilterName) {
                                                    const selectedFilter = savedFilters.find(filter => filter.filter_name === selectedFilterName);
                                                    if (selectedFilter) {
                                                        applyFilter(selectedFilter.filter_data);
                                                        populateFilter(selectedFilterName);
                                                    }
                                                }
                                            }}
                                        >
                                            <option value="">Filtre Seçin</option>
                                            {savedFilters.map((filter, index) => (
                                                <option key={index} value={filter.filter_name}>
                                                    {filter.filter_name}
                                                </option>
                                            ))}
                                        </select>

                                        <button
    onClick={() => {
        const selectedFilterName = document.getElementById('savedFilterDropdown').value;
        const selectedFilter = savedFilters.find(f => f.filter_name === selectedFilterName);
        if (selectedFilter) {
            deleteFilter(selectedFilter.id);
        }
    }}
    className="btn btn-link delete-button"
>
    &times;
</button>

                                    </div>
                                ) : null}

                                {!selectedDate && savedFilters.length === 0 && (
                                    <p className="no-filters-message">Henüz kayıtlı filtre yok</p>
                                )}
                            </div>

                            {hiddenHeaders.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <h5>Gizlenen Sütunlar</h5>
                                    <div className="hidden-columns-container">
                                        {hiddenHeaders.map((header, index) => (
                                            <div key={index} className="hidden-column">
                                                <span>{header}</span>
                                                <button
                                                    onClick={() => toggleHeaderVisibility(header)}
                                                    className="restore-column-button"
                                                >
                                                    <i className="fas fa-check"></i> {/* Font Awesome checkmark */}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}


                            {/* Populate Filter Mesajları */}
                            {populateError && <div className="alert alert-danger mt-2">Hata: {populateError}</div>}
                            {populateSuccess && <div className="alert alert-success mt-2">Başarı: {populateSuccess}</div>}
                        </div>

                        {/* Sağda Filtre Temizle ve Kaydet Butonları */}
                        <div className="col-lg-6 button-container">
                            <button onClick={clearFilters} className="btn btn-secondary">Filtreleri Temizle</button>
                            <button onClick={saveFilter} className="btn btn-primary">Filtreyi Kaydet</button>
                        </div>


                    </div>

                    {error && <div>Hata: {error}</div>}
                    {success && <div>Başarı: {success}</div>}

                    {/* Filtreleme tablosu */}
                    {!error && (
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr className="top-header">
                                        {columns.map((column, index) => (
                                            !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                <th colSpan={column.subColumns.length} key={index}>
                                                    <div className="column-header">
                                                        {column.header}
                                                        <input
                                                            type="checkbox"
                                                            checked={!hiddenHeaders.includes(column.header)}
                                                            onChange={() => toggleHeaderVisibility(column.header)}
                                                            className="column-header-checkbox"
                                                        />
                                                    </div>
                                                </th>
                                            ) : null
                                        ))}
                                    </tr>
                                    <tr>
                                        {columns.map((column, index) => (
                                            !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                column.subColumns.map(subColumn => (
                                                    <th key={subColumn.key}>
                                                        {subColumn.header}
                                                        <input
                                                            type="text"
                                                            className="filter-input"
                                                            placeholder={`Filtre`}
                                                            value={inputValues[subColumn.key] || ''}
                                                            onChange={(e) => handleFilterChange(subColumn.key, e.target.value)}
                                                        />
                                                    </th>
                                                ))
                                            ) : null
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.length > 0 ? (
                                        filteredData.map((item, index) => (
                                            <tr key={index}>
                                                {columns.map((column) => (
                                                    !hiddenHeaders.includes(column.header) && column.subColumns ? (
                                                        column.subColumns.map(subColumn => (
                                                            <td key={subColumn.key}>{item[subColumn.key]}</td>
                                                        ))
                                                    ) : null
                                                ))}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={columns.reduce((sum, column) => sum + (column.subColumns ? column.subColumns.length : 1), 0)}>Veri bulunamadı</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}

export default KapanisOran;